"use strict";

const topScrollFix = document.querySelector("[data-js='topScrollFix']");

if (topScrollFix) {
  window.addEventListener("scroll", topScrollFixed);

  let position = topScrollFix.offsetTop;

  function topScrollFixed() {
    if (window.pageYOffset >= position) {
      topScrollFix.classList.add("selection-header-fixed");
    } else {
      topScrollFix.classList.remove("selection-header-fixed");
    }
  }
}

const topScrollFixInner = document.querySelector(
  "[data-js='topScrollFixInner']"
);
const topScrollFixInnerWrapper = document.querySelector(
  "[data-js='topScrollFixInnerWrapper']"
);
// const endOfScroll = document.querySelector("[data-js='endOfScroll']");

let imagePreviewGrid = document.querySelector(".image-preview-grid");

if (topScrollFixInner) {
  window.addEventListener("load", topScrollFixedInner);
  window.addEventListener("scroll", topScrollFixedInner);
  window.addEventListener("resize", topScrollFixedInner);

  function topScrollFixedInner() {
    let positionInner = topScrollFixInnerWrapper.offsetTop;
    let positionInnerHeight = topScrollFixInnerWrapper.offsetHeight;

    if (window.pageYOffset >= positionInner && window.innerWidth > 991) {
      topScrollFixInner.classList.add("selection-inner-fixed");
      topScrollFixInner.classList.remove("selection-inner-fixed-mob");

      if (window.pageYOffset >= positionInnerHeight - 32) {
        topScrollFixInner.classList.add("selection-inner-stop-position");
      } else {
        topScrollFixInner.classList.remove("selection-inner-stop-position");
      }
    } else if (window.pageYOffset > 50 && window.innerWidth <= 991) {
      topScrollFixInner.classList.add("selection-inner-fixed-mob");
      topScrollFixInner.classList.remove("selection-inner-fixed");

      if (imagePreviewGrid) {
        imagePreviewGrid.classList.add("special-mb");
      }
    } else {
      topScrollFixInner.classList.remove("selection-inner-fixed-mob");
      topScrollFixInner.classList.remove("selection-inner-fixed");

      if (imagePreviewGrid) {
        imagePreviewGrid.classList.remove("special-mb");
      }
    }
  }
}

const topScrollFixInnerRating = document.querySelector(
  "[data-js='topScrollFixInnerRating']"
);
const topScrollFixInnerRatingWrapper = document.querySelector(
  "[data-js='topScrollFixInnerRatingWrapper']"
);
// const endOfScroll = document.querySelector("[data-js='endOfScroll']");

if (topScrollFixInnerRating) {
  window.addEventListener("load", topScrollFixedInner);
  window.addEventListener("scroll", topScrollFixedInner);
  window.addEventListener("resize", topScrollFixedInner);

  function topScrollFixedInner() {
    let positionInner = topScrollFixInnerRatingWrapper.offsetTop;
    let positionInnerHeight = topScrollFixInnerRatingWrapper.offsetHeight;

    if (window.pageYOffset >= positionInner && window.innerWidth > 991) {
      topScrollFixInnerRating.classList.add("selection-inner-fixed");
      topScrollFixInnerRating.classList.remove(
        "selection-inner-fixed-mob-rating"
      );

      if (window.pageYOffset >= positionInnerHeight - 32) {
        topScrollFixInnerRating.classList.add("selection-inner-stop-position");
      } else {
        topScrollFixInnerRating.classList.remove(
          "selection-inner-stop-position"
        );
      }
    } else if (window.pageYOffset > 50 && window.innerWidth <= 991) {
      topScrollFixInnerRating.classList.add("selection-inner-fixed-mob-rating");
      topScrollFixInnerRating.classList.remove("selection-inner-fixed");

      if (imagePreviewGrid) {
        imagePreviewGrid.classList.add("special-mb");
      }
    } else {
      topScrollFixInnerRating.classList.remove(
        "selection-inner-fixed-mob-rating"
      );
      topScrollFixInnerRating.classList.remove("selection-inner-fixed");

      if (imagePreviewGrid) {
        imagePreviewGrid.classList.remove("special-mb");
      }
    }
  }
}

const topScrollFixInnerMapFilter = document.querySelector(
  "[data-js='topScrollFixInnerMapFilter']"
);
const topScrollFixInnerMapFilterWrapper = document.querySelector(
  "[data-js='topScrollFixInnerMapFilterWrapper']"
);
// const endOfScroll = document.querySelector("[data-js='endOfScroll']");

if (topScrollFixInnerMapFilter) {
  window.addEventListener("load", topScrollFixedInnerMapFilter);
  window.addEventListener("scroll", topScrollFixedInnerMapFilter);
  window.addEventListener("resize", topScrollFixedInnerMapFilter);

  function topScrollFixedInnerMapFilter() {
    let positionInner = topScrollFixInnerMapFilterWrapper.offsetTop;
    let positionInnerHeight = topScrollFixInnerMapFilterWrapper.offsetHeight;

    if (window.pageYOffset >= positionInner && window.innerWidth > 991) {
      topScrollFixInnerMapFilter.classList.add("selection-inner-fixed");
      topScrollFixInnerMapFilter.classList.remove("selection-inner-fixed-mob");

      if (window.pageYOffset >= positionInnerHeight - 135) {
        topScrollFixInnerMapFilter.classList.add(
          "selection-inner-stop-position"
        );
      } else {
        topScrollFixInnerMapFilter.classList.remove(
          "selection-inner-stop-position"
        );
      }
    } else if (window.pageYOffset > 50 && window.innerWidth <= 991) {
      topScrollFixInnerMapFilter.classList.add("selection-inner-fixed-mob");
      topScrollFixInnerMapFilter.classList.remove("selection-inner-fixed");

      if (imagePreviewGrid) {
        imagePreviewGrid.classList.add("special-mb");
      }
    } else {
      topScrollFixInnerMapFilter.classList.remove("selection-inner-fixed-mob");
      topScrollFixInnerMapFilter.classList.remove("selection-inner-fixed");
      topScrollFixInnerMapFilter.classList.remove(
        "selection-inner-stop-position"
      );

      if (imagePreviewGrid) {
        imagePreviewGrid.classList.remove("special-mb");
      }
    }
  }
}

const topScrollFixInnerObject = document.querySelector(
  "[data-js='topScrollFixInnerObject']"
);
const topScrollFixInnerObjectWrapper = document.querySelector(
  "[data-js='topScrollFixInnerObjectWrapper']"
);
// const endOfScroll = document.querySelector("[data-js='endOfScroll']");

if (topScrollFixInnerObject) {
  window.addEventListener("load", topScrollFixedInnerObject);
  window.addEventListener("scroll", topScrollFixedInnerObject);
  window.addEventListener("resize", topScrollFixedInnerObject);

  function topScrollFixedInnerObject() {
    let positionInner = topScrollFixInnerObjectWrapper.offsetTop;
    let positionInnerHeight = topScrollFixInnerObjectWrapper.offsetHeight;
    let positionInnerHeightEl = topScrollFixInnerObject.offsetHeight;

    if (window.pageYOffset >= positionInner && window.innerWidth > 991) {
      topScrollFixInnerObject.classList.add("selection-inner-fixed");
      topScrollFixInnerObject.classList.remove("selection-inner-fixed-mob");

      if (
        window.pageYOffset >
        positionInnerHeight + (positionInnerHeightEl - 100)
      ) {
        topScrollFixInnerObject.classList.add("selection-inner-stop-position");
      } else {
        topScrollFixInnerObject.classList.remove(
          "selection-inner-stop-position"
        );
      }
    } else if (window.pageYOffset > 50 && window.innerWidth <= 991) {
      topScrollFixInnerObject.classList.add("selection-inner-fixed-mob");
      topScrollFixInnerObject.classList.remove("selection-inner-fixed");

      if (imagePreviewGrid) {
        imagePreviewGrid.classList.add("special-mb");
      }
    } else {
      topScrollFixInnerObject.classList.remove("selection-inner-fixed-mob");
      topScrollFixInnerObject.classList.remove("selection-inner-fixed");

      if (imagePreviewGrid) {
        imagePreviewGrid.classList.remove("special-mb");
      }
    }
  }
}

const topScrollFixInnerContact = document.querySelector(
  "[data-js='topScrollFixInnerContact']"
);
const topScrollFixInnerContactWrapper = document.querySelector(
  "[data-js='topScrollFixInnerContactWrapper']"
);

if (topScrollFixInnerContact) {
  window.addEventListener("load", topScrollFixedInnerContact);
  window.addEventListener("scroll", topScrollFixedInnerContact);
  window.addEventListener("resize", topScrollFixedInnerContact);

  function topScrollFixedInnerContact() {
    let positionInner = topScrollFixInnerContactWrapper.offsetTop;
    let positionInnerHeight = topScrollFixInnerContactWrapper.offsetHeight;

    if (window.pageYOffset >= positionInner && window.innerWidth > 991) {
      topScrollFixInnerContact.classList.add("selection-inner-fixed");
      topScrollFixInnerContact.classList.remove("selection-inner-fixed-mob");

      if (window.pageYOffset >= positionInnerHeight - 32) {
        topScrollFixInnerContact.classList.add("selection-inner-stop-position");
      } else {
        topScrollFixInnerContact.classList.remove(
          "selection-inner-stop-position"
        );
      }
    } else if (window.pageYOffset > 50 && window.innerWidth <= 991) {
      topScrollFixInnerContact.classList.add("selection-inner-fixed-mob");
      topScrollFixInnerContact.classList.remove("selection-inner-fixed");
    } else {
      topScrollFixInnerContact.classList.remove("selection-inner-fixed-mob");
      topScrollFixInnerContact.classList.remove("selection-inner-fixed");
    }
  }
}
